import React, { useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Box, Card } from '@mui/material'
import { LocationState } from 'types/routerLocation'

import {
  CaptchaFooter,
  LoginForm,
  LogInHeader,
  LogInNav,
  OtpForm
} from './components'

let toggledWarningFromPrevLocation = false

export default function LogIn() {
  // reads the redirect error, if any, and toasts it to the client
  const location = useLocation() as LocationState
  if (location?.state?.reason && !toggledWarningFromPrevLocation) {
    toggledWarningFromPrevLocation = true
    toast.error(location.state.reason)
  }

  // initialize recaptcha
  const { executeRecaptcha } = useGoogleReCaptcha()

  // Switch between Otp and Email
  const [email, setEmail] = useState('')

  const onReset = () => {
    setEmail('')
  }

  const OrbitHeader = () => (
    <Box
      sx={{
        width: '50vw',
        color: '#FFFFFF',
        fontStyle: 'roboto',
        fontWeight: 900,
        fontSize: '3em',
        maxWidth: '600px',
        margin: '0 auto'
      }}
    >
      Autopiloting your way to Customer Happiness.
    </Box>
  )

  const LogInPageBody = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100vw'
      }}
    >
      <OrbitHeader />
      <Box
        display='flex'
        justifyContent='flex-end'
        sx={{
          marginRight: '75px',
          width: '500px'
        }}
      >
        <Card>
          <Box
            display='flex'
            flexDirection='column'
            justifyContent='space-between'
            alignItems='center'
            sx={{
              height: '75vh',
              maxWidth: '450px',
              overflowY: 'hidden',
              padding: `36px 2rem`
            }}
          >
            <Box
              sx={{
                width: '370px',
                overflowY: 'auto'
              }}
            >
              <LogInHeader />
              {!email ? (
                <LoginForm
                  setEmail={setEmail}
                  executeRecaptcha={executeRecaptcha}
                />
              ) : (
                <OtpForm
                  email={email}
                  executeRecaptcha={executeRecaptcha}
                  onReset={onReset}
                />
              )}
              <CaptchaFooter />
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  )

  return (
    <Box
      className='background'
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='space-evenly'
      height='100vh'
      sx={{
        padding: '1rem'
      }}
    >
      <LogInNav />
      <LogInPageBody />
    </Box>
  )
}
